
<template>
  <div class="module-box elevation-2 mb-2">
    <v-layout row wrap>
      <v-flex xs1 class="align-table py-0"><strong>{{ ind+1 }}</strong></v-flex>
      <v-flex xs2 class="text-xs-center align-table py-0"><strong>{{ classMod.days[0].day | convertDateCheck }}</strong></v-flex>
      <v-flex xs2 class="text-xs-center align-table py-0"><strong>{{ classMod.days[0].room_name || '--' }}</strong></v-flex>
      <v-flex xs7 class="pa-0">
        <v-select class="ma-0 pa-0 mr-3" color="black" flat v-model="currentModule" :items="gridsProccess" item-text="name" item-value="id" @change="changeModule()" hide-details return-object single-line dense required></v-select>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ['class-mod', 'ind', 'grids'],
  data() {
    return {
      currentModule: { name: 'SEM MODULO!', id: null },
      gridsProccess: []
    }
  },
  methods: {
    changeModule() {
      this.$emit('moduleChanged', { currentModule: this.currentModule, modId: this.classMod.id, ind: this.ind })
    }
  },
  watch: {
    grids() {
      this.gridsProccess = this.grids.concat([{ name: 'SEM MODULO!', id: null }])
    }
  },
  created() {
    if (this.classMod.module_id != null) {
      this.currentModule = { name: this.classMod.module_name, id: this.classMod.module_id }
    }
  }
}
</script>

<style scoped>
  .align-table {
    display: flex;
    justify-content: center; /* align horizontal */
    align-items: center;
  }
</style>
